/* Установщик «Маркетплейс»: объект в window на том месте порядка скриптов, где стоял assets/bot-market.js. */
import { createMarket } from './engine';

export function installMarket() {
  createMarket();
}
